import styled, { css } from 'styled-components';

import { black, boxShadow1 } from 'utils/style/colors';
import { zindex } from 'utils/style/zindex';
import { scaleUp, fadeIn, fadeOut } from 'utils/style/animations';

const transitionName = 'modal';

const scaleUpAnimation = css`
  ${scaleUp} 0.3s ease;
`;

const fadeInAnimation = css`
  ${fadeIn} 0.3s ease;
`;

const fadeOutAnimation = css`
  ${fadeOut} 0.3s ease;
`;

interface IModalMain {
  width: string;
  height?: string;
}

interface IModalHeader {
  hasTab: boolean;
}

interface ITabItem {
  active: boolean;
}

export const ModalContainer = styled.aside`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  z-index: ${zindex.modal};
  transform: translateZ(0);
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  ${(props) =>
    props.isAlert &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    `}

  &.${transitionName}-enter {
    animation: ${fadeInAnimation};
  }
  &.${transitionName}-exit {
    animation: ${fadeOutAnimation};
  }
`;

export const ModalMain = styled('div')<IModalMain>`
  max-height: ${(props) => !props.isAlert && '90% !important'};
  display: flex;
  padding: 0;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  flex-direction: column;
  background-color: var(--exact-white);
  animation: ${scaleUpAnimation};
  width: ${(props) => props.width || 'calc(min(95%,1200px))'};
  margin: ${(props) => !props.isAlert && 'auto'};
  min-height: ${(props) => props.isAlert && '10%'};
  max-height: ${(props) => props.isAlert && '20%'};
  @media screen and (max-width: 800px) {
    margin: auto !important;
    width: ${(props) => props.width || 'calc(min(95%,1200px))'};
  }
  ${(props) => props.height && `height : ${props.height} !important`}
`;

export const ModalHeader = styled('header')<IModalHeader>`
  color: ${black};
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: space-between;
  padding-bottom: ${(props) => (props.hasTab ? 0 : '0.5rem')};
`;

export const HeaderText = styled.div`
  font-style: normal;
  font-weight: 500 !important;
  font-size: 14px !important;
  width: 100%;
  line-height: 24px;
  display: block;
  font-weight: bold !important;
  font-size: 1.1rem !important;
`;
export const ModalHeaderInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const TabsList = styled.div`
  display: flex;
  margin-top: 1em;
`;

export const TabItem = styled('span')<ITabItem>`
  margin: 0 0.5rem;
  transition: all 0.2s;
  padding-bottom: 0.5rem;
  color: ${(props) => (props.active ? black : '#828A90')};
  cursor: ${(props) => (props.active ? 'default' : 'pointer')};
  box-shadow: ${(props) => (props.active ? `inset 0 -3px ${black}` : '')};
  &:hover {
    box-shadow: ${(props) => (!props.active ? 'inset 0 -3px #828A90' : '')};
    color: ${(props) => (!props.active ? black : '')};
  }
`;

export const ModalBody = styled.main`
  flex: 1;
  display: flex;
  overflow: auto;
  min-height: ${(props) => (props.isAlert ? '1rem' : '5rem')};
  flex-direction: column;
  :focus-visible {
    outline: none;
  }
  outline: none;
  padding: ${(props) => (props.isAlert ? '0.5rem' : '1.5rem 1rem')};
`;

// Alert Modal
export const AlertModalContainer = styled.div`
  & > * {
    position: fixed;
    right: 0;
    bottom: 0;
    height: 100vh;
    width: 100vw;
  }
`;

export const AlertModalBody = styled.main`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  flex: 1;
`;
export const AlertModalIconContainer = styled.div`
  margin: 0.5rem;
`;
export const AlertModalContent = styled.div`
  flex: 1;
  font-weight: bold;
  font-size: 1rem !important;
`;
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  margin: 0.5rem;
`;

export const Banner = styled.div`
  width: 99%;
  border-radius: 1rem;
  box-shadow: ${boxShadow1};
  height: 15rem;
  margin: 1rem;
`;

export const Content = styled('article')`
  width: 100%;
  flex: 1;
  max-height: 80vh;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  margin-top: 2rem;

  & > h3 {
    font-weight: bold;
    font-size: 2.2rem !important;
    margin: 1rem auto 3rem;
  }

  & > div {
    flex: 1;
    width: 100%; //${(props) => (props.isFullScreen ? '100%' : '70%')};
    margin: 0 auto;
    & img {
      // height: ${(props) => (props.isFullScreen ? '100%' : '20rem')};
      border-radius: 1rem;
      margin: 1rem auto;
    }

    @media screen and (max-width: 600px) {
      width: 100%;

      & figure {
        width: 90% !important;
      }

      // & img {
      //   height: ${(props) => (props.isFullScreen ? '100%' : '25rem')};
      // }
    }
  }

  & iframe {
    height: 100% !important;
  }
`;
